import React from 'react';
import { BookOpen, Settings, CheckCircle2 } from 'lucide-react';

const navigation = [
  { name: 'Dashboard', href: '/students/dashboard', icon: BookOpen },
  { name: 'Completed', href: '/students/completed-assessments', icon: CheckCircle2 },
  { name: 'Settings', href: '/students/settings', icon: Settings },
];

export function StudentBottomNavigation() {
  const handleNavigation = (href) => {
    window.location.href = `#${href}`;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 py-2 sm:hidden">
      <div className="flex justify-around">
        {navigation.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.name}
              onClick={() => handleNavigation(item.href)}
              className="flex flex-col items-center justify-center p-3 text-gray-600 hover:text-action-blue transition-colors"
            >
              <Icon className="h-6 w-6 mb-1" />
              <span className="text-xs font-medium">{item.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
